import { BenefitDTO, RecreationBenefitDetailsDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class RecreationBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsRecreation = activeBenefit.details as RecreationBenefitDetailsDTO;

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.name`,
      navigateTo: '/recreation',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: `benefitModule:benefit.${activeBenefit.benefit}.description`,
      descriptionValues: {
        refund: detailsRecreation.refund,
        maxRefund: detailsRecreation.maxRefund,
      },
      benefitProgress:
        detailsRecreation.maxRefund > 0 ? Math.min(100, Math.max(0, (detailsRecreation.refund / detailsRecreation.maxRefund) * 100)) : 0,
    };
  }
}
